export default __webpack_public_path__ + "static/media/yichao_ma_cv.c5455d05.pdf";